import { render, staticRenderFns } from "./addAlbum.vue?vue&type=template&id=46f1e80d&scoped=true&"
import script from "./addAlbum.vue?vue&type=script&lang=js&"
export * from "./addAlbum.vue?vue&type=script&lang=js&"
import style0 from "./addAlbum.vue?vue&type=style&index=0&id=46f1e80d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f1e80d",
  null
  
)

export default component.exports